export default __webpack_public_path__ + "static/media/transactionssnap_icon.c458e159.svg";